import gtag from "./init/analytics.init";
import * as repos from "./contentrepositories";

export const scripts = {
  methods: {
    loadScript(src, id) {
      if (!document.getElementById(id)) {
        const s = document.createElement("script");
        const async = document.createAttribute("async");
        const defer = document.createAttribute("defer");
        s.src = src;
        s.id = id;
        s.setAttributeNode(async);
        s.setAttributeNode(defer);
        document.head.appendChild(s);
        return s;
      }
      return false;
    },
    unLoadScript(node) {
      document.head.removeChild(node);
    }
  }
};

export const navigate = {
  methods: {
    navigateBack() {
      // eslint-disable-next-line
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    navigateToMomentEntry() {
      this.$router.push({ name: "AddMoment" });
    },
    navigateToExport() {
      this.$router.push({ name: "Export" });
    }
  }
};

export const translate = {
  methods: {
    translate(thingToTranslate) {
      const locale = this.$store.state.locale || "nl";
      if (typeof thingToTranslate === "object") {
        return thingToTranslate[locale];
      }
      return thingToTranslate;
    }
  }
};

export const googleTags = {
  methods: {
    gTagEvent(eventName, eventParams) {
      return gtag("event", eventName, eventParams);
    },
    gTagScreenView(screenName) {
      // eslint-disable-next-line @typescript-eslint/camelcase
      return gtag("event", "screen_view", { screen_name: screenName });
    }
  }
};

export const momentVariations = {
  methods: {
    expandedMoment(moment) {
      moment.emotionObjects = moment.emotions ? moment.emotions.map(emo => repos.emotionRepository.getById(emo)) : [];
      moment.behaviourObjects = moment.behaviour ? moment.behaviour.map(emo => repos.behaviourRepository.getById(emo)) : [];
      moment.locationObject = repos.locationRepository.getById(moment.location) || {};
      moment.partyObject = repos.partyRepository.getById(moment.party) || {};
      moment.typeObject = repos.momentTypeRepository.getById(moment.type) || {};
      return moment;
    },
    flaggedMoments(moments) {
      return moments.filter(m => m.flagged);
    }
  }
};
